import React from 'react';
import { Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import { Arrow } from '../../Common/Icon';
import HowMuchToTip from './HowMuchToTip';
import SplittingTheBill from './SplittingTheBill';
import JoinOurCommunity from '../TippingArticles/JoinOurCommunity';
import ShareYourTwoCents from './ShareYourTwoCents';
import ShareButton from '../../Common/ShareButton';
import CategoryProvider from '../Home/HowMuchToTip/CategoryProvider';
import { TipProvider } from './TipContextProvider';

import styles from './index.module.scss';

export default function TipCalculatorContent(): React.ReactElement {
  const navigate = useNavigate();

  return (
    <>
      <div className={styles.wrapper}>
        <div className={styles.container}>
          <div className={styles.content}>
            <div className={styles.innerWrapper}>
              <div className={styles.title}>
                <h1 style={{ color: '#000000' }}>Tip</h1>
                <h1 style={{ color: '#11B559' }}>Calculator</h1>
              </div>
              <div className={styles.rightTitle}>
                <h2 style={{ color: '#000000' }}>
                  Find the perfect tip—calculate now!
                </h2>
                <Button
                  type="default"
                  size="large"
                  icon={<Arrow />}
                  className={styles.button}
                  onClick={() => navigate('/categories')}
                >
                  View all industries
                </Button>
              </div>
            </div>
            <div className={styles.innerWrapper}>
              <div>
                <h3>
                  Take the guesswork out of tipping - use our calculator now:
                </h3>
                <ul style={{ fontSize: 17 }}>
                  <li>
                    Using the drop down menu, select the industry or service you
                    are tipping for.
                  </li>
                  <li>
                    You can select either the customer or worker average tip
                    percentage or enter a custom amount.
                  </li>
                  <li>Enter the bill total.</li>
                  <li>
                    Select the number of people splitting the bill (if
                    applicable).
                  </li>
                  <li>The calculator will then provide the tip and total.</li>
                </ul>
                <ShareButton />
              </div>
              <div>
                <h3>
                  Calculate your tip using real data from U.S. customers and
                  industry workers.
                </h3>
                <span style={{ fontWeight: 300 }}>
                  <p>
                    The “Customer Average” suggested percentage is the average
                    tip amount real U.S.-based customers say they leave for
                    average service.
                  </p>
                  <p>
                    The “Worker Average” suggested percentage is the average tip
                    real U.S.-based industry workers expect for average service.
                  </p>
                  <p>
                    Average service refers to service that meets basic
                    expectations without standing out as exceptional or poor.
                  </p>
                </span>
              </div>
            </div>
            <TipProvider>
              <div className={styles.items}>
                <div className={styles.item}>
                  <CategoryProvider>
                    <HowMuchToTip />
                  </CategoryProvider>
                </div>
                <div className={styles.item}>
                  <SplittingTheBill />
                  <ShareYourTwoCents />
                </div>
              </div>
            </TipProvider>
          </div>
        </div>
      </div>
      <JoinOurCommunity />
    </>
  );
}
